
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function ServiceAreas() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation();

  const areas = [
    {
      name: 'Nashville',
      description: 'Historic estates and urban elegance',
      image: 'https://public.readdy.ai/ai/img_res/5ed8f704a0127ce1bb4324b91beee30f.jpg'
    },
    {
      name: 'Brentwood',
      description: 'Grand residences and private estates',
      image: 'https://readdy.ai/api/search-image?query=luxurious%20Brentwood%20Tennessee%20estate%20home%20exterior%20twilight%20elegant%20architecture%20upscale%20neighborhood%20refined%20southern%20mansion%20manicured%20landscape%20grand%20entrance&width=800&height=600&seq=area-brentwood&orientation=landscape'
    },
    {
      name: 'Franklin',
      description: 'Southern charm meets refined living',
      image: 'https://readdy.ai/api/search-image?query=elegant%20Franklin%20Tennessee%20historic%20home%20exterior%20southern%20architecture%20refined%20estate%20warm%20evening%20light%20classical%20design%20upscale%20residence%20charming%20setting&width=800&height=600&seq=area-franklin&orientation=landscape'
    },
    {
      name: 'Green Hills',
      description: 'Sophisticated urban residences',
      image: 'https://readdy.ai/api/search-image?query=upscale%20Green%20Hills%20Nashville%20luxury%20home%20exterior%20modern%20elegant%20architecture%20refined%20residential%20area%20sophisticated%20design%20warm%20lighting%20exclusive%20neighborhood&width=800&height=600&seq=area-greenhills&orientation=landscape'
    },
    {
      name: 'Belle Meade',
      description: 'Timeless elegance and prestige',
      image: 'https://readdy.ai/api/search-image?query=prestigious%20Belle%20Meade%20Nashville%20historic%20mansion%20exterior%20classical%20architecture%20elegant%20estate%20refined%20southern%20grandeur%20manicured%20grounds%20luxury%20residence%20timeless%20beauty&width=800&height=600&seq=area-bellemeade&orientation=landscape'
    }
  ];

  return (
    <section id="service-areas" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        {/* Header */}
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`grid lg:grid-cols-2 gap-12 mb-16 animate-fade-up ${headerVisible ? 'in-view' : ''}`}
        >
          <div>
            <h2 className="font-sans text-4xl lg:text-5xl font-bold mb-2">
              <span className="block text-gray-400">Where We</span>
              <span className="block text-gray-900 italic font-serif">Bring the Salon</span>
            </h2>
          </div>
          <div className="flex items-center">
            <p className="text-gray-700 text-lg leading-relaxed">
              We serve Nashville's most distinguished neighborhoods, bringing world-class artistry to your private residence.
            </p>
          </div>
        </div>

        {/* Areas Grid */}
        <div
          ref={gridRef as React.RefObject<HTMLDivElement>}
          className={`grid md:grid-cols-2 lg:grid-cols-3 gap-8 animate-fade-up delay-200 ${gridVisible ? 'in-view' : ''}`}
        >
          {areas.map((area, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="w-full h-64 rounded-2xl overflow-hidden mb-4 shadow-md group-hover:shadow-xl transition-shadow duration-300">
                <img
                  src={area.image}
                  alt={area.name}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="inline-block bg-amber-100 text-amber-800 text-sm font-medium px-4 py-1.5 rounded-full mb-3">
                {area.name}
              </div>
              <h3 className="text-gray-900 font-medium text-lg">{area.description}</h3>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 italic">Additional locations available by request</p>
        </div>
      </div>
    </section>
  );
}
